import type { files as fileContracts } from '@personal-blog/contracts';
import { triggerBrowserDownload } from '@/lib/download';

export function ownedFileContentUrl(file: fileContracts.File): string {
  return file.publicUrl ?? `/api/me/files/${encodeURIComponent(file.id)}/content`;
}

export function groupFileContentUrl(file: fileContracts.File, groupSlug: string): string {
  return `/api/groups/${encodeURIComponent(groupSlug)}/library/files/${encodeURIComponent(file.id)}/content`;
}

export function publicFileContentUrl(file: fileContracts.File): string | null {
  if (file.partition !== 'public-downloads') return null;
  return file.publicUrl ?? `/api/files/${encodeURIComponent(file.id)}/content`;
}

export function fileContentUrl(file: fileContracts.File, groupSlug?: string | null): string {
  if (typeof groupSlug === 'string' && groupSlug.length > 0) {
    return groupFileContentUrl(file, groupSlug);
  }
  return ownedFileContentUrl(file);
}

export function downloadFile(file: fileContracts.File, groupSlug?: string | null): void {
  triggerBrowserDownload(fileContentUrl(file, groupSlug), file.name, {
    rel: 'noopener noreferrer',
  });
}

export function copyName(name: string): string {
  const dot = name.lastIndexOf('.');
  if (dot <= 0) return `${name}-copy`;
  return `${name.slice(0, dot)}-copy${name.slice(dot)}`;
}
